import $ from 'jquery';
import slide from './slide';

window.jQuery = $;
window.$ = $;
import 'slick-carousel';

$(function() {

  var $headerSlider = $('.header-slider'),
      $sliderBackground = $('.page-teaser .slider-background'),
      $sliderContent = $('.page-teaser .slider-content'),
      $sliderContentItems = $sliderContent.find('.item'),
      $navItems = $('.page-teaser .navigation .item'),
      $slickArrow = false;

  if($headerSlider.length > 0) {
    $headerSlider.css('visibility', 'hidden');
  }

  $sliderBackground.find('.slider-item').each(slide);
  
  $sliderBackground
  .slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    cssEase:'ease-out',
    asNavFor: '.element-type-gridelements-slider .slider-content',
    pauseOnHover: false,
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 1300,
  });

  $sliderContent.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    asNavFor: '.element-type-gridelements-slider .slider-background',
    fade: true,
    cssEase:'ease-out',
    prevArrow: '<span class="slick-prev icon-chevron-left"></span>',
    nextArrow: '<span class="slick-next icon-chevron-right"></span>',
    pauseOnHover: false,
    slickPlay: false,
    swipeToSlide: false
  });
  
  $sliderBackground.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var $nextContentSlide = $sliderContentItems.eq(nextSlide);
    if (!$slickArrow) {
      $slickArrow = $('.slick-arrow');
    }

    $navItems.removeClass('active');
    $navItems.eq(nextSlide).addClass('active');

    //slick.$slides.eq(nextSlide).find('.slider-item').addClass('image-animation');

    $nextContentSlide.removeClass('none')
        .removeClass('black');

    if ($nextContentSlide.hasClass('slider-layout-white')) {
      $nextContentSlide.addClass('black');
    }

    if ($nextContentSlide.hasClass('slider-layout-none')) {
      $nextContentSlide.addClass('none');
    }

  });

  $navItems.each(function () {
    var $this = $(this);

    $this.bind('click', function () {
      var $this = $(this),
          index = $this.find('a').attr('data-index');

      $sliderBackground.slick('slickGoTo', parseInt(index), true);
    });

  });

  $(document).ready(function() {
    if($headerSlider.length > 0) {
      $headerSlider.css('visibility', 'visible');
    }
  });

  window.onresize = function () {
    if($headerSlider.length > 0) {
      $headerSlider.css('visibility', 'hidden');

      $headerSlider.css('visibility', 'visible');
    }
  };

});